import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginFormComponent } from './login/login.component';
import { TenantDetailsComponent } from './tenants/tenantDetails/tenantDetails.component';
import { TenantsComponent } from './tenants/tenants.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { TenantBillingComponent } from './tenants/tenantBilling/tenantBilling.component';
import { DatePipe } from '@angular/common';
import { TrimDirective } from './directives/texttrim';
import { SortDirective } from './directives/sortDirective';
import { UpdatePasswordFormComponent } from './updatePassword/updatePassword.component';
import { ForgotPasswordFormComponent } from './forgotPassword/forgotPassword.component';
import { PopupComponent } from './popup/popup.component';
import { PrivacyPolicyComponent } from './privacyPolicy/privacyPolicy.component';
import { ApiClientsComponent } from './apiClients/apiClients.component';
import { ApiClientDetailsComponent } from './apiClients/apiClientDetails/apiClientDetails.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    NgxPaginationModule,
    NgbModule
  ],
  providers: [
    DatePipe,
    provideHttpClient(withInterceptorsFromDi())
  ],
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginFormComponent,
    TenantsComponent,
    TenantDetailsComponent,
    HeaderComponent,
    FooterComponent,
    TrimDirective,
    SortDirective,
    UpdatePasswordFormComponent,
    ForgotPasswordFormComponent,
    PopupComponent,
    PrivacyPolicyComponent,
    ApiClientsComponent,
    ApiClientDetailsComponent,
    TenantBillingComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
